import { createWithEqualityFn } from 'zustand/traditional';
import { shallow } from 'zustand/shallow';

const initialSavedCountry = JSON.parse(window.localStorage.getItem('selectedCountry'));
const countryCode = window.localStorage.getItem('selectedCountryId');
const productTour = window.localStorage.getItem('productTour');

const defaults = {
  general: {
    favoriteCountryId: countryCode,
    showProductTour: !productTour || productTour === 'true', // if var doesn't exist on LS or is true it will set showProductTour true, if not false
  },
  country: {
    selectedCountry: initialSavedCountry, // full object
    countryName: initialSavedCountry ? initialSavedCountry.name : '',
    countryId: initialSavedCountry ? initialSavedCountry.countryId : '',
    countryTheme: initialSavedCountry ? initialSavedCountry.theme : {},
    siteUrl: initialSavedCountry ? initialSavedCountry.siteUrl : '',
    contact: initialSavedCountry ? initialSavedCountry.contact : {},
    brand: initialSavedCountry ? initialSavedCountry.brand : '',
  },
  batch: {
    batchData: {},
    userBatch: '',
    stageDetails: [],
    exampleBatch: '',
    daysForDistribution: 0,
  },
  recipes: {
    recipesList: [],
    recipe: {},
  },
};

const useStore = createWithEqualityFn(
  (set) => ({
    // COUNTRY
    ...defaults.country,
    setSelectedCountry: (country) => {
      set((state) => {
        window.localStorage.setItem('selectedCountry', JSON.stringify(country));

        return {
          ...state,
          countryId: country.countryId,
          name: country.name,
          theme: country.theme,
        };
      });
    },
    setCountryName: (name) => {
      set((state) => ({ ...state, countryName: name }));
    },
    setCountryId: (id) => {
      set((state) => ({ ...state, countryId: id }));
    },
    setCountryTheme: (theme) => {
      set((state) => ({ ...state, countryTheme: theme }));
    },
    setSiteUrl: (url) => {
      set((state) => ({ ...state, siteUrl: url }));
    },
    setContact: (url) => {
      set((state) => ({ ...state, contact: url }));
    },
    setBrand: (brand) => {
      set((state) => ({ ...state, brand: brand }));
    },
    // GENERAL
    ...defaults.general,
    setFavoriteCountryId: (countryId) => {
      window.localStorage.setItem('selectedCountryId', JSON.stringify(countryId));
      set((state) => ({ ...state, favoriteCountryId: countryId }));
    },
    setShowProductTour: (productTour) => {
      window.localStorage.setItem('productTour', JSON.stringify(productTour));
      set((state) => ({ ...state, showProductTour: productTour }));
    },
    // BATCH
    ...defaults.batch,
    setBatchData: (data) => {
      set((state) => ({ ...state, batchData: data }));
    },
    setUserBatch: (data) => {
      set((state) => ({ ...state, userBatch: data }));
    },
    setStageDetails: (details) => {
      set((state) => ({ ...state, stageDetails: details }));
    },
    setExampleBatch: (batch) => {
      set((state) => ({ ...state, exampleBatch: batch }));
    },
    setDaysForDistribution: (days) => {
      set((state) => ({ ...state, daysForDistribution: days }));
    },
    // recipes
    ...defaults.recipes,
    setRecipesList: (r) => {
      set((state) => ({ ...state, recipesList: r }));
    },
    setRecipe: (r) => {
      set((state) => ({ ...state, recipe: r }));
    },
  }),
  shallow,
);

/* * * GENERAL * * */

// getters
export const selectFavoriteCountryId = (state) => state.favoriteCountryId;
export const selectShowProductTour = (state) => state.showProductTour;

// setters
export const selectSetFavoriteCountryId = (state) => state.setFavoriteCountryId;
export const selectSetShowProductTour = (state) => state.setShowProductTour;

/* * * COUNTRY * * */

// getters
export const selectSelectedCountry = (state) => state.selectedCountry;
export const selectCountryName = (state) => state.countryName;
export const selectCountryId = (state) => state.countryId;
export const selectCountryTheme = (state) => state.countryTheme;
export const selectSiteUrl = (state) => state.siteUrl;
export const selectContact = (state) => state.contact;
export const selectBrand = (state) => state.brand;

// setters
export const selectSetSelectedCountry = (state) => state.setSelectedCountry;
export const selectSetCountryName = (state) => state.setCountryName;
export const selectSetCountryId = (state) => state.setCountryId;
export const selectSetCountryTheme = (state) => state.setCountryTheme;
export const selectSetSiteUrl = (state) => state.setSiteUrl;
export const selectSetContact = (state) => state.setContact;
export const selectSetBrand = (state) => state.setBrand;

/* * * BATCH * * */

// getters
export const selectBatchData = (state) => state.batchData;
export const selectUserBatch = (state) => state.userBatch;
export const selectStageDetails = (state) => state.stageDetails;
export const selectExampleBatch = (state) => state.exampleBatch;
export const selectDaysForDistribution = (state) => state.daysForDistribution;

// setters
export const selectSetBatchData = (state) => state.setBatchData;
export const selectSetUserBatch = (state) => state.setUserBatch;
export const selectSetStageDetails = (state) => state.setStageDetails;
export const selectSetExampleBatch = (state) => state.setExampleBatch;
export const selectSetDaysForDistribution = (state) => state.setDaysForDistribution;

/* * * recipes * * */

// getters
export const selectRecipesList = (state) => state.recipesList;
export const selectRecipe = (state) => state.recipes;

// setters
export const selectSetRecipesList = (state) => state.setRecipesList;
export const selectSetRecipe = (state) => state.setRecipe;

export default useStore;
